export default {
  fields: {
    country: 'Paese della banca',
    iban: 'IBAN',
    routing_number: 'Numero di instradamento (routing)',
    account_number: 'Numero di conto',
    sort_code: 'Sort code',
    account_type: 'Tipo di conto',
  },
  help: {
    country: 'Il paese della banca, che può essere diverso da quello del ristorante.',
  },
  placeholders: {
    iban: 'DE89 3704 0044 0532 0130 00',
  },
  formats: {
    uk_local: {
      title: 'Sort code e numero di conto',
      description: 'Il modo abituale per inserire un conto del Regno Unito.',
    },
    iban: {
      title: 'IBAN',
      description: 'Il codice internazionale del conto bancario.',
    },
    us_local: {
      title: 'Routing e numero di conto',
      description: 'Un conto bancario statunitense.',
    },
  },
  account_types: {
    checking: 'Conto corrente',
    savings: 'Conto di risparmio',
  },
  actions: {
    save: 'Salva conto bancario',
    cancel: 'Annulla',
    edit: 'Modifica',
  },
  card: {
    account: 'Conto',
    country: 'Paese',
    status: 'Stato',
  },
  statuses: {
    active: 'Attivo',
    pending_verification: 'In verifica',
    action_needed: 'Azione richiesta',
    errored: 'Pagamento non riuscito',
    missing: 'Mancante',
  },
  notes: {
    pending_verification:
      'Adyen controlla ogni conto bancario prima dell’avvio dei pagamenti. Confermalo sulla pagina di Adyen con l’accesso alla banca o un estratto conto.',
    action_needed:
      'Il fornitore di pagamenti non ha potuto confermare questo conto bancario. Controlla i dati o inserisci un altro conto.',
    errored:
      'Un pagamento verso questo conto non è riuscito e i pagamenti sono sospesi. Controlla i dati o inserisci un altro conto.',
  },
};
